import Select from 'react-select'

const SelectBundle = ({ value, callback, style, opt, placeholder }) => {
  return (
    <Select
      options={opt}
      styles={style}
      placeholder={placeholder}
      menuPlacement="auto"
      isSearchable={false}
      value={opt.find((f) => f.value === value) || ''}
      onChange={callback}
    />
  )
}

export default SelectBundle
